import React from "react";
import VerifieAuthentification from "./fermer-enregistrement/verifie-authentification";

export default function ProfileFermerEnregistrementTab({ language }) {
  return (
    <div className="profile-options-tab" data-language={language || ""}>
      <VerifieAuthentification showConnectedMessage={false} />
    </div>
  );
}